import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import QuoteWizardNavigation from './components/QuoteWizardNavigation';
import { II18nMessages } from '../../../../services/branding/models';
import { withRouter } from 'react-router';
import { flow, forEach } from 'lodash';
import { IHeaderActions } from './models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as headerActions } from './reducer';
import { IChannel } from '../../../../data/api/models';
import { destroy } from 'redux-form';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { push } from 'react-router-redux';
import { IStore } from '../../../../redux/IStore';
import { IAuthState } from '../../../../services/auth/models';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import * as Commonmark from 'react-commonmark';

interface IHeaderProps {
  classes: any;
  isDrawerOpened: boolean;
  i18n: II18nMessages;
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    header: IHeaderActions;
    quote: IQuoteActions;
    destroy(formName: string);
  };
  steps: object;
  location: any;
  channel: IChannel;
  quote: IQuoteState;
}

interface IHeadersStates {
  openMenu: boolean;
  windowSize: boolean;
}

class Header extends React.Component<IHeaderProps, IHeadersStates> {
  public state = {
    openMenu: false,
    windowSize: false,
  };

  public componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  public resize() {
    this.setState({ windowSize: window.innerWidth <= 992 });
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this));
  }

  private renderWelcomeMessage = () => {
      const { channel } = this.props;
      if (!channel.products[0].metadata.welcome_message) {
        return null;
      }
      const welcomeMessage = channel.products[0].metadata.welcome_message;
      return (
        <Commonmark
          source={welcomeMessage}
        />
      );
  }

  private renderBanner = () => {
    const {channel} = this.props;
    let logoSrc = null;
    let logoAlt = null;
    let logoLink = null;

    if (['fps-b2c', 'fpr-b2c'].includes(channel.key)) {
      logoSrc = require('./img/fps_logo_small.png');
      logoAlt = 'Forces Pension Society';
      logoLink = 'https://quote.forcespensionsociety.org';
    }

    if (['npo-b2c', 'npor-b2c'].includes(channel.key)) {
      logoSrc = require('./img/npo_logo_small.png');
      logoAlt = 'NARPO Insurance';
      logoLink = 'https://quote.narpotravelcover.org.uk';
    }

    if (['cspa-b2c', 'cspar-b2c'].includes(channel.key)) {
      logoSrc = require('./img/cspa_logo_small.png');
      logoAlt = 'CSPA Travel Insurance';
      logoLink = 'https://quote.cspatravelcover.org.uk';
    }

    if (['css-b2c', 'cssr-b2c'].includes(channel.key)) {
      logoSrc = require('./img/css_logo_small.svg');
      logoAlt = 'Combined Services Insurance';
      logoLink = 'https://quote.combinedservicestravelcover.org.uk';
    }

    return (
      <div className="logo-container">
        <a className="navbar" href={logoLink}>
          <img className="logo" src={logoSrc} alt={logoAlt} />
        </a>
      </div>
    );
  }

  private renderLinks = () => {
    const {channel, auth, location } = this.props;
    const isInAuthArea = location.pathname.match(/(auth)/);

    if (channel.channelType === 'AGG') {
      return null;
    }

    return (
      <div>
        <Navbar collapseOnSelect={true}>
          <Navbar.Header>
            <Navbar.Toggle/>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight={true} className="links">
              {isInAuthArea && !auth.isAuthenticated ? (
                <LinkContainer to="/" exact={true}>
                  <NavItem eventKey={1}>
                    GET A QUOTE
                  </NavItem>
                </LinkContainer>
              ) : (
                <LinkContainer to={auth.isAuthenticated ? '/account/summary' : '/auth/login'} exact={true}>
                  <NavItem
                    eventKey={1}
                    href={auth.isAuthenticated ? '/account/summary' : '/auth/login'}
                  >
                    {auth.isAuthenticated ? 'MY ACCOUNT' : 'LOGIN'}
                  </NavItem>
                </LinkContainer>
              )}
              <NavItem
                eventKey={2}
                href={channel.urls.aboutUs}
                target="_blank"
                disabled={false}>
                ABOUT US
              </NavItem>
              <NavItem eventKey={3} href={channel.urls.contactUs} target="_blank" disabled={false}>
                CONTACT
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }

  private renderWizardNavigation = () => {
    const {steps, location, i18n, channel} = this.props;

    let currentStep = '';
    let isInQuoteProcess = false;

    forEach(steps, (step) => {
      if (step.route === location.pathname) {
        currentStep = step.key;
        isInQuoteProcess = true;
      }
    });

    if (isInQuoteProcess) {
      return (
        <QuoteWizardNavigation i18n={i18n} steps={steps} currentStep={currentStep} channel={channel} />
      );
    }
  }

  public render() {
    const { channel, quote, location } = this.props;
    const hasAggError = quote.aggError;
    const openingHours = channel.openingHours;
    let openingHoursElement = <div className="opening-hours">{openingHours}</div>;

    let classes = '';

    if (channel.channelType === 'AGG') {
      classes += ' aggregator';
    }

    if (['npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c'].includes(channel.key) && this.state.windowSize) {
      const openingHoursMultiLine = openingHours[0].split(',');

      openingHoursElement = (
          <div><div className="opening-hours">{openingHoursMultiLine[0]}</div>
        <div className="opening-hours">{openingHoursMultiLine[1]}</div></div>
      );
    }

    if (channel.key === 'dia-b2c') {
      return (
        <header className={classes} style={{ minHeight: '175px' }}>
          <div className="container dia-header-height">
            {this.renderBanner()}
          </div>
          {location.pathname === '/trip-details' && (
            <div className="container welcome-message">
              {this.renderWelcomeMessage()}
            </div>
          )}
          {!hasAggError && (
            <div className="">
              {this.renderWizardNavigation()}
            </div>
          )}
        </header>
      );
    } else {
      return (
        <header className={classes}>
          {this.renderLinks()}
         <div className="container">
            <div className="header-container">
              {this.renderBanner()}
              {!hasAggError && (
                <div className="more-info-container">
                  <div className="phone">
                    {channel.phone}
                  </div>
                  {openingHoursElement}
                  <div className="website-url">
                    <a href={`https://${channel.urls.mainPage}`} target="_blank">{channel.urls.mainPage}</a>
                  </div>
                </div>
              )}
            </div>
          </div>
          {!hasAggError && (
              <div className="wizard-container">
                {this.renderWizardNavigation()}
              </div>
          )}
        </header>
      );
    }
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      isDrawerOpened: state.header.isDrawerOpened,
      i18n: state.branding.i18n,
      channel: state.branding.channel,
      auth: state.auth,
      quote: state.quote,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        header: bindActionCreators({...headerActions}, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
  withRouter,
])(Header);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Header/index.tsx